import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { varColor } from "../../utils/themeHelpers";
import { typographyCoreStyles, typographyStyles } from "../common/Typography";
import { ButtonReset, splitButtonMixin } from "./Button.mixins";

export const BaseGroupButtonMixins = {
    background: (props: { selected?: boolean }) => ({
        backgroundColor: props.selected
            ? varColor("primary", "steel03")
            : "transparent",
    }),

    color: (props: { selected?: boolean }) => ({
        color: props.selected ? varColor("primary", "white") : undefined,
    }),
};

export const BaseGroupButton = styled.button<{ selected?: boolean }>(
    ButtonReset,
    typographyCoreStyles,
    typographyStyles.list,
    splitButtonMixin,
    css`
        flex-grow: 1;
        flex-shrink: 1;
        overflow-x: hidden;

        gap: ${8 / 16}rem;

        &:only-of-type {
            border-top-right-radius: ${4 / 16}rem;
            border-bottom-right-radius: ${4 / 16}rem;
        }

        &:first-of-type {
            border-top-left-radius: ${4 / 16}rem;
            border-bottom-left-radius: ${4 / 16}rem;
        }

        &:disabled {
            opacity: 0.33;
        }

        transition: background-color 33ms;
    `,
    BaseGroupButtonMixins.background,
    BaseGroupButtonMixins.color,
);
